import url from "../../../../url.js";
export default {
  name: "About",
  data() {
    return {
      title: "Tentang Kami",
      text: {
        Judul: "Tentang Kami",
        pt: "PT Fastana Warehouse Indonesia",
        Isi: "Perusahaan penyedia layanan pergudangan dan logistik yang berfokus pada efisiensi, keamanan, dan kemudahan dalam penyimpanan serta distribusi barang. Dengan pengalaman lebih dari 10 tahun di bidang logistik dan manajemen gudang, kami hadir sebagai solusi bagi bisnis Anda yang membutuhkan ruang penyimpanan yang terpercaya, terorganisir, dan strategis. Kami memiliki jaringan gudang yang tersebar di berbagai lokasi strategis, dilengkapi dengan sistem keamanan modern dan teknologi manajemen pergudangan berbasis digital (Warehouse Management System - WMS). Didukung oleh tim profesional dan berpengalaman, kami memastikan setiap barang klien ditangani secara optimal dan tepat waktu.",
        visi: "Visi: Menjadi penyedia layanan pergudangan dan logistik terdepan di Indonesia yang terpercaya, efisien, dan berbasis teknologi",
        misi: "Misi: Kami berkomitmen untuk menyediakan layanan pergudangan yang aman, modern, dan mudah diakses; mengembangkan sistem logistik berbasis digital untuk meningkatkan efisiensi operasional; serta memberikan solusi penyimpanan yang fleksibel dan sesuai kebutuhan, dengan didukung oleh tenaga profesional dan sistem manajemen mutu untuk mendukung distribusi yang tepat waktu dan akurat.",
        passion:
          "Menjadi solusi utama dalam mendukung efisiensi dan keandalan rantai pasok melalui layanan pergudangan yang terintegrasi dan terpercaya.",
      },
      dataFasilitas: [],
      dataMilestone: [],
      ApiUrl: url.API_URL,
    };
  },
  methods: {
    async fetchData() {
      const response = await fetch(this.ApiUrl + "m143_advantages/id/2");
      const data = await response.json();
      this.dataFasilitas = data;
    },
    async fetchMilestone() {
      const response = await fetch(`${this.ApiUrl}m140_milestones/id/1`);
      const data = await response.json();
      this.dataMilestone = data;
    },
  },
  mounted() {
    this.fetchData();
    // this.fetchMilestone();
  },
};
